import { create } from 'zustand';
import { LastTestClientReset, TestClientResetState } from '../services/TestClientResetService';

export const isResetRunning = (lastReset?: LastTestClientReset | null): boolean =>
  !!lastReset && lastReset.status !== 'completed';

// Estado do reset do cliente de teste (HML): o monitor do NavBar atualiza, o item do menu lê.
type TestClientResetStore = {
  resetState: TestClientResetState | null;
  finishedReset: LastTestClientReset | null;
  // Aplica o estado vindo do backend; um reset que estava rodando e terminou vira finishedReset (o aviso lê de lá).
  applyResetState: (resetState: TestClientResetState | null) => void;
  setLastReset: (lastReset: LastTestClientReset) => void;
  setFinishedReset: (finishedReset: LastTestClientReset | null) => void;
  resetTestClientResetStore: () => void;
};

const initialState = { resetState: null, finishedReset: null };

export const useTestClientResetStore = create<TestClientResetStore>(set => ({
  ...initialState,
  applyResetState: resetState =>
    set(state => {
      const finished =
        isResetRunning(state.resetState?.lastReset) && resetState?.lastReset && !isResetRunning(resetState.lastReset);
      return finished ? { resetState, finishedReset: resetState.lastReset } : { resetState };
    }),
  setLastReset: lastReset => set(state => (state.resetState ? { resetState: { ...state.resetState, lastReset } } : state)),
  setFinishedReset: finishedReset => set({ finishedReset }),
  resetTestClientResetStore: () => set(initialState),
}));
